module.exports = __webpack_public_path__ + "img/Screen-L@-design-2.319eb459.png";